export const TEST_POLICY_ID: string = "ea32676207d0478347d50d01473db64f964237e9912bd8a592eef269";
export const TEST_PROJECT_ID: string = "preprodiecpTou8tNNXmfHWpZn4xYod9rcTlWk9"
export const TEST_SATURN_ID: string = "38572bad-75fc-4bd3-bb43-c6d2f96ecded"
// "c14eb384-c787-47ec-bbc4-8981ad204e6e"


// export const TEST_SATURN_ID: string = "e8653d16-8070-4d8d-a784-59bb00d1fb56"
// prep preprodiecpTou8tNNXmfHWpZn4xYod9rcTlWk9